import * as _ from 'lodash';
import * as React from 'react';
import { Col } from 'reactstrap';
import { Svg } from 'src/components/shared/Svg';
import { INotation } from 'src/model';

interface INotationProps {
  label: string;
  notationList: INotation[];
  handleClick: (label: string, notation: 1 | 2 | 3 | 4 | 5) => void;
}

export const Notation: React.SFC<INotationProps> = ({
  label,
  notationList,
  handleClick,
}) => {
  const currentNotation = _.find(notationList, { label })
    ? _.find(notationList, { label })
    : { notation: 0 };

  return (
    <Col md='4' xs='auto' className='mb-5'>
      <span>{label}</span>
      <div className='d-flex align-items-center mt-3'>
        {[1, 2, 3, 4, 5].map((notation: 1 | 2 | 3 | 4 | 5, key: number) => (
          <Svg
            className='mr-2'
            key={key}
            width={24}
            height={24}
            fill={
              currentNotation && currentNotation.notation <= key
                ? 'dark'
                : 'warning'
            }
            opacity={
              currentNotation && currentNotation.notation <= key ? 0.25 : 1
            }
            src='star'
            onClick={() => handleClick(label, notation)}
          />
        ))}
      </div>
    </Col>
  );
};



// WEBPACK FOOTER //
// ./src/components/Project/ProjectEvaluation/EvaluationProposition/Notation.tsx